import axios from 'axios';
import VueRouter from 'vue-router';
import Vue from 'vue';

export function initAxios(store: any, router: VueRouter) {
    axios.defaults.baseURL = process.env.VUE_APP_API_URL;
    Vue.prototype.$axios = axios;

    if (store.state.account) {
        axios.defaults.headers.Authorization = 'Bearer ' + store.state.account.access_token;
    }

    axios.interceptors.response.use(
      (response) => {
        // if (response.headers['x-auth-token']) {
        //   const user = store.state.user;
        //   user.auth_token = response.headers['x-auth-token'];
        //   axios.defaults.headers.Authorization = "Bearer " + user.auth_token;
        //   store.commit('USER', user);
        // }
    
        return response;
      },
      (error) => {
        if ((error.response && error.response.status === 401) && (location.href.indexOf("/login") === -1)) {
          store.commit("ACCOUNT", null);
          delete axios.defaults.headers.Authorization;
          localStorage.removeItem('account');
          router.replace(`/login`);
    
          return;
        }
    
        return Promise.reject(error)
      }
    );
}